import { FormField } from '@cp/ds/src/components/form';
import React from 'react';
import { RangeInputValueItemRenderFn } from '@cp/ds/src/components/form/components/field/range/model';
import { Box } from '@cp/ds/src/components/box';
import { useTheme } from '@cp/ds/src/hooks';
import { FormFieldName } from '../model/form';

export const AgeField: React.FC = () => {
  const theme = useTheme();

  const renderValueItem = React.useCallback<RangeInputValueItemRenderFn>(
    (newValue, { index }) => (
      <React.Fragment>
        <Box component="span" sx={{ color: 'gray' }}>
          {index ? 'до' : 'от'}
        </Box>{' '}
        {newValue} лет
      </React.Fragment>
    ),
    [],
  );

  return (
    <FormField
      fieldLabel="Возраст"
      max={60}
      min={18}
      name={FormFieldName.Age}
      renderValueItem={renderValueItem}
      size="small"
      step={5}
      sx={{ width: 1, backgroundColor: theme.palette.white }}
      type="range"
    />
  );
};
